<template>
<div class="chapter">
<div class="inner_page">
<p class="fmtitle"><a id="page_vii"><span class="bb">Contents</span></a></p><a id="page_vii">
</a><p class="toc"><a id="page_vii"></a><a href="#/xhtml/08_ListofIll">List of Illustrations</a></p>
<p class="toca"><a href="#/xhtml/09_Preface">Preface</a></p>
<p class="toca"><a href="#/xhtml/10_Acknowledgement">Acknowledgments</a></p>
<p class="toc"><a href="#/xhtml/12_Prologue">Prologue</a></p>
<p class="toc"><a href="#/xhtml/13_Part01"><b><span class="bb">Part I</span></b></a></p>
<p class="toc1"><a href="#/xhtml/14_Chapter01"><i>Chapter 1</i><br/>The British Violate Their Terms and Rule by Edict</a></p>
<p class="toc1"><span href="#/xhtml/15_Chapter02" title="Link target outside of Sample"><i>Chapter 2</i><br/>A Proud and Haughty Scot Takes Command of Charleston</span></p>
<p class="toc1"><span href="#/xhtml/16_Chapter03" title="Link target outside of Sample"><i>Chapter 3</i><br/>A Fierce and Unrelenting Soldier Comes in from the Field</span></p>
<p class="toc"><span href="#/xhtml/17_Part02" title="Link target outside of Sample"><b><span class="bb">Part II</span></b></span></p>
<p class="toc1"><span href="#/xhtml/18_Chapter04" title="Link target outside of Sample"><i>Chapter 4</i><br/>“I do not mean to desert the cause of America”</span></p>
<p class="toc1"><span href="#/xhtml/19_Chapter05" title="Link target outside of Sample"><i>Chapter 5</i><br/>The Captor Becomes the Captive</span></p>
<p class="toc1"><span href="#/xhtml/20_Chapter06" title="Link target outside of Sample"><i>Chapter 6</i><br/>“The imminent and shocking doom of the most unfortunate Mr. Hayne”</span></p>
<p class="toc1"><span href="#/xhtml/21_Chapter07" title="Link target outside of Sample"><i>Chapter 7</i><br/>“We seriously lament the necessity of such a severe expedient”</span></p>
<p class="toc"><a id="page_viii"></a><span href="#/xhtml/22_Part03" title="Link target outside of Sample"><b><span class="bb">Part III</span></b></span></p>
<p class="toc1"><span href="#/xhtml/23_Chapter08" title="Link target outside of Sample"><i>Chapter 8</i><br/>Rawdon’s Fantastic Shipboard Recollections</span></p>
<p class="toc1"><span href="#/xhtml/24_Chapter09" title="Link target outside of Sample"><i>Chapter 9</i><br/>“In South Carolina no one even knows where he is buried”</span></p>
<p class="toc1"><span href="#/xhtml/25_Chapter10" title="Link target outside of Sample"><i>Chapter 10</i><br/>A Survey of the Story of Isaac Hayne in Art and Literature</span></p>
<p class="toc"><span href="#/xhtml/26_Appendix01" title="Link target outside of Sample"><i>Appendix A</i><br/>The Proclamations of Lt. Gen. Sir Henry Clinton</span></p>
<p class="toc1"><span href="#/xhtml/27_Appendix02" title="Link target outside of Sample"><i>Appendix B</i><br/>The Correspondence between Col. Isaac Hayne and His British Captors</span></p>
<p class="toc1"><span href="#/xhtml/28_Appendix03" title="Link target outside of Sample"><i>Appendix C</i><br/>John Colcock’s Legal Brief: “Case of Colonel Hayne”</span></p>
<p class="toc1"><span href="#/xhtml/29_Appendix04" title="Link target outside of Sample"><i>Appendix D</i><br/>Ladies’ Petition for Colonel Isaac Hayne</span></p>
<p class="toc1"><span href="#/xhtml/30_Notes" title="Link target outside of Sample">Notes</span></p>
<p class="toc1"><span href="#/xhtml/31_Bibliography" title="Link target outside of Sample">Bibliography</span></p>
<p class="toc1"><span href="#/xhtml/32_Index01" title="Link target outside of Sample">Index</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 07_Contents.vue?3f18278e